var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpencv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.3333 52.6667C43.6573 52.6667 40.6666 49.676 40.6666 46C40.6666 43.6254 41.944 41.4134 44 40.2267L46 43.6907C45.178 44.1654 44.6666 45.05 44.6666 46C44.6666 47.4454 45.888 48.6667 47.3333 48.6667C48.7786 48.6667 50 47.4454 50 46C50 45.05 49.4886 44.1654 48.6666 43.6907L50.6666 40.2267C52.7226 41.4134 54 43.626 54 46C54 49.676 51.0093 52.6667 47.3333 52.6667Z",
    fill: "#448AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3334 39.086L41.3334 35.622C42.1554 35.1473 42.6667 34.262 42.6667 33.3127C42.6667 31.8673 41.4454 30.646 40 30.646C38.5547 30.646 37.3334 31.8673 37.3334 33.3127C37.3334 34.2627 37.8447 35.1473 38.6667 35.622L36.6667 39.086C34.6107 37.8987 33.3334 35.686 33.3334 33.312C33.3334 29.636 36.324 26.6453 40 26.6453C43.676 26.6453 46.6667 29.636 46.6667 33.312C46.6667 35.6867 45.3894 37.8993 43.3334 39.086Z",
    fill: "#FF1744"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6673 52.6853C30.3613 52.6853 28.116 51.49 26.882 49.354C25.044 46.17 26.1386 42.0853 29.322 40.2466C31.3786 39.0593 33.9333 39.0593 35.9886 40.2466L33.9886 43.7106C33.166 43.2353 32.1446 43.2353 31.322 43.7106C30.07 44.4333 29.6233 46.1013 30.3453 47.3533C31.068 48.6046 32.736 49.0526 33.9886 48.3293C34.8106 47.8546 35.322 46.9693 35.322 46.02H39.322C39.322 48.394 38.0446 50.606 35.9886 51.7933C34.942 52.3986 33.7966 52.6853 32.6673 52.6853Z",
    fill: "#9CCC65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpencv);
export default __webpack_public_path__ + "static/media/opencv.e9abe6a653a8d8a57e4a6a20b9eebf1e.svg";
export { ForwardRef as ReactComponent };